import { db } from '../db/index.js';
import { getDeviceId } from '../db/meta.js';
import { purgeExpired } from '../db/repo/trash.js';
import { maybeDailyLocalSnapshot } from '../backup/localSnapshots.js';
import { initAuth } from '../features/auth/authStore.js';
import { toast } from '../components/Toaster.jsx';

let started = false;

export async function requestPersistentStorage() {
  if (!navigator.storage?.persist) return null;
  try {
    if (await navigator.storage.persisted()) return true;
    return await navigator.storage.persist();
  } catch {
    return false;
  }
}

export async function bootstrap() {
  if (started) return;
  started = true;
  try {
    await db.open();
    await getDeviceId(db);
  } catch (e) {
    console.error(e);
    toast.error(
      'This browser blocked local storage (private mode?). Recall needs it to keep your cards offline.',
      { duration: 0 },
    );
    return;
  }
  requestPersistentStorage();
  initAuth().catch((e) => console.error('Auth init failed', e));
  // Housekeeping off the critical path.
  setTimeout(async () => {
    try {
      await maybeDailyLocalSnapshot(db);
      await purgeExpired(db);
    } catch (e) {
      console.warn('Housekeeping failed', e);
    }
  }, 3000);
}
